import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Artists from './components/Artists'
import UpcomingEvents from './components/UpcomingEvents'
import PastEvents from './components/PastEvents'
import Releases from './components/Releases'
import Connect from './components/Connect'
import ConnectRedirect from './components/ConnectRedirect'
import Footer from './components/Footer'
import CurrentStreams from './components/CurrentStreams'
import ConnectPage from './pages/ConnectPage'
import MixesPage from './pages/MixesPage'
import ReleasesPage from './pages/ReleasesPage'
import ScrollToTop from './components/ScrollToTop'
import './styles/App.css'

function MainContent() {
  // Handle hash navigation on initial page load
  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Get the hash without the '#' symbol
      const id = window.location.hash.substring(1);
      
      // Wait for components to render
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          // Get navbar height for offset
          const navHeight = 80; // Adjust this value based on your navbar height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - navHeight;
          
          // Scroll to the element
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300); // Shorter timeout since we're in the MainContent component
    }
  }, []);
  
  return (
    <>
      <Navbar />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <CurrentStreams />
        <section id="about">
          <About />
        </section>
        <section id="upcoming-events">
          <UpcomingEvents />
        </section>
        <section id="artists">
          <Artists />
        </section>
        <section id="past-events">
          <PastEvents />
        </section>
        <section id="releases">
          <Releases />
        </section>
        <section id="connect">
          <Connect />
        </section>
      </main>
      <Footer />
    </>
  );
}

// Google Analytics route tracking component
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Send pageview to Google Analytics
    // Use setTimeout to ensure this doesn't interfere with other scripts
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_location: window.location.href
        });
      }
    }, 100);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <RouteTracker />
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/connect" element={<ConnectRedirect />} />
          <Route path="/mixes" element={<MixesPage />} />
          <Route path="/releases" element={<ReleasesPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
